import { useDispatch, useSelector } from 'react-redux';
import ContentLoader from 'react-content-loader';
import { useEffect, useState } from 'react';
import useRequestRedwolfService from '../../common/hooks/useRequestRedwolfService';
import { authAPI } from '../../../services/redwolfSdkAPI';
import { setUserProfile, UserProfile } from '../../../store/userSlice';
import { getToken } from '../../../utils/localStorage';
import useTechnicalErrorMessage from '../../common/hooks/useTechnicalErrorMessage';
import * as Sentry from '@sentry/react';

const Username = () => {
	const {
		account: { user }
	} = useSelector((state: any) => state.user);
	const [isSkeletonLoading, setIsSkeletonLoading] = useState(false);
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();
	const [requestRedwolfService] = useRequestRedwolfService();
	const dispatch = useDispatch();
	const token = getToken();

	const getSignInType = (responseData: any) => {
		let signInType = '';
		if (
			responseData.appleId === '' &&
			responseData.facebookId === '' &&
			responseData.googleId === ''
		) {
			signInType = 'TRADITIONAL';
		} else if (responseData.appleId !== '') {
			signInType = 'apple';
		} else if (responseData.facebookId !== '') {
			signInType = 'facebook';
		} else if (responseData.googleId !== '') {
			signInType = 'google';
		}
		return signInType;
	};

	useEffect(() => {
		if (!user) {
			setIsSkeletonLoading(true);

			requestRedwolfService(authAPI.getUser(token))
				.then((userResponse: any) => {
					setIsSkeletonLoading(false);

					if (userResponse.constructor.$metadata$.simpleName === 'Success' && userResponse.data) {
						const responseData = userResponse.data;

						const signInType = getSignInType(responseData);
						//TODO:(1) Review requiresCreateUser - Its not part of the accountAPI.login

						const userProfile: UserProfile = {
							firstName: responseData.firstName,
							lastName: responseData.lastName,
							email: responseData.email,
							userId: responseData.userId,
							signInType: signInType,
							requiresCreateUser: false,
							isUserLoggedIn: true,
							emailVerified: responseData.emailVerified,
							requiresEmailVerification: responseData.requiresEmailVerification,
							requiresPersonalization: responseData.requiresPersonalization
						};

						dispatch(setUserProfile({ userProfile, user: responseData }));
					}
				})
				.catch((err: any) => {
					setIsSkeletonLoading(false);
					showTechnicalErrorMessage();
					Sentry.captureException(err);
				});
		}
	}, []);

	return (
		<>
			{isSkeletonLoading ? (
				<ContentLoader viewBox="0 0 400 15">
					<rect x="0" y="0" rx="2" ry="2" width="150" height="15" />
				</ContentLoader>
			) : (
				<h1 className="h1">Hi, {user && user.firstName}</h1>
			)}
		</>
	);
};

export default Username;
